<template>
  <div class="barWrapper">
    <div class="bar_style" ref="bar_statistics" style='width:100%;height:100%;'></div>
  </div>
</template>

<script>
  import EChart from 'echarts'
  import {loopShowTooltip} from '../../libs/js/echart-tooltip-carousel'

  export default {
    props:{
        status: {
            type: Object,
            default: {}
        },
    },
    data() {
      return {
        bar_statistics: {
          option: {},
          chart: null,
          element: {},
        },
        data:{},
        chartArray:['bar_statistics']
      }
    },
    mounted() {

        //this.onWindowResize()
        this.$nextTick(()=>{
            setTimeout(()=>{
                window.addEventListener('resize', this.onWindowResize)
                this.onWindowResize();
            },1500);
        });
    },
     beforeDestroy(){
      this.bar_statistics.chart.clear();
      window.removeEventListener('resize',this.onWindowResize);
    },
    destory() {
    //   window.removeEventListener('resize',this.onWindowResize);
    },
    watch:{
        status:{
            handler:function(newVal,oldVal){
              setTimeout(()=>{
                this.pageInit();
              },1000)
            },
            deep:true
        }
    },
    methods: {
      onWindowResize(){
            // let pageHeight = document.documentElement.clientHeight; //页面总高度
            // let barStyle = document.querySelectorAll(".status")[0].clientHeight;
            let barStyle = null;
            if(document.querySelectorAll(".left_wrap") && document.querySelectorAll(".left_wrap")[0])barStyle = document.querySelectorAll(".left_wrap")[0].clientHeight;
            if(document.querySelectorAll(".bar_style") && document.querySelectorAll(".bar_style")[0]){
            document.querySelectorAll(".bar_style")[0].style.height =  barStyle - 50 + 'px';  //在这里可以根据你的边距做调整
                if(JSON.stringify(this.status) !== "{}")this.disposeAllChart();
            }
      },
      pageInit(){
            this.data = this.$deepClone(this.status);
            this.initData();
      },
      initData() {
        var scale = 1;
        var color = "#216a7c";
        console.log('bar_statistics-=-=-=-'+JSON.stringify(this.data))
        this.bar_statistics.option = {
            tooltip: {
                show:true,
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
                backgroundColor: 'rgba(0,0,0,0.7)', // 背景
                padding: [8, 10], //内边距
                extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
            },
            legend: {
                data: this.data.name,
                align: 'left',
                // orient:'vertical',
                itemGap: 10,
                // x: 'right',
                top:'5%',
                right:'5%',
                icon: 'roundRect',
                itemWidth: 12*scale, // 图例图形宽度
                itemHeight: 12*scale, // 图例图形高度
                textStyle: {
                    color: "#3fdaff",
                    fontSize: 14,
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '0%',
                containLabel: true
            },
            xAxis: [{
                type: 'category',
                data: this.data.x_data,
                axisLabel: {
                    // inside: true,
                    interval: 0,
                    textStyle: {
                        color: "#08a6ad",
                        // fontSize: 14,  //大
                        fontSize: 12,
                    }
                },
                axisTick: {
                    show:false,
                    lineStyle: {
                        color: color,
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: color,
                    }
                },
                // splitLine: {
                //     lineStyle: {
                //         color: 'rgba(80,224,255,0.3)',
                //         type: 'dashed'
                //     }
                // }
            }],
            yAxis: [{
                type: 'value',
                max:100,
                axisLabel: {
                    // inside: true,
                    textStyle: {
                        color: '#64c7e7',
                        fontSize: 14,
                    }
                },
                axisTick: {
                    show:false,
                    lineStyle: {
                        color: color,
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: color,
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(80,224,255,0.3)',
                        type: 'dashed'
                    },
                    show:false,
                },
                name: '(%)',
                nameTextStyle: {
                    color: "#65c6e7",
                    fontSize: 14,
                    padding: [0, 0, 10, 0]
                }
            }],
        };
        let series_data = this.data.series_data;
        console.log('=-==---series_data=--=-'+JSON.stringify(series_data))
        var  color = ['#009944','#d2d2d2','#ffc600'];
        this.bar_statistics.option.series=[];
        if(series_data && series_data.length){
          series_data.forEach((item,index) => {
              let datas=item.data.map(function(a){return parseInt(a*100,10)});   //数组每一项乘100
              color.forEach((i,n) =>{
                  if(index==n){
                      item.color = i;
                      var series= {
                          name:item.name,
                          type: 'bar',
                          barWidth: '15%',
                          barGap:'40%',
                          itemStyle: {
                              normal: {
                                  color:i,
                              }
                          },
                          data: datas
                      }
                      this.bar_statistics.option.series.push(series)
                  }
              })
          });
        }

        // this.bar_statistics.option.series=[
        //         {
        //             name: '在线率',
        //             type: 'bar',
        //             barWidth: '15%',
        //             barGap:'40%',
        //             itemStyle: {
        //                 normal: {
        //                     color:'#009944',
        //                 }
        //             },
        //             data: [30,50,60,70,30,20,40]
        //         }, {
        //             name: '离线率',
        //             type: 'bar',
        //             barWidth: '15%',
        //             barGap:'40%',
        //             itemStyle: {
        //                 normal: {
        //                     color: '#d2d2d2',
        //                 }
        //             },
        //             data: [10,40,30,24,56,67,80]
        //         }, {
        //             name: '维修率',
        //             type: 'bar',
        //             barWidth: '15%',
        //             barGap:'40%',
        //             itemStyle: {
        //                 normal: {
        //                     color: '#ffc600',
        //                 }
        //             },
        //             data: [44,33,28,91,34,50,24]
        //         },
        //     ]

        // if(this.bar_statistics.chart!=null&&this.bar_statistics.chart!=''&&this.bar_statistics.chart!=undefined){
        //   this.bar_statistics.chart.dispose();
        // }
        this.bar_statistics.chart = EChart.init(this.$refs.bar_statistics);
        this.bar_statistics.chart.setOption(this.bar_statistics.option);
        // loopShowTooltip(this.bar_statistics.chart,this.bar_statistics.option,{loopSeries:true});
      },
        //释放图表，销毁对象
        disposeAllChart(){
            let i = 0 , len = this.chartArray.length
            for (;i < len; i++){
                let a = this.chartArray[i]
                if(this[a].chart){
                    this[a].chart.dispose()
                }
            }
            this.initData()
        }
    }
  }
</script>
<style scoped lang="less">
.barWrapper{
    width:100%;
    height: 100%;
    .bar_style {
    border-right: 0;
    border-left: 0;
    width: 100%;
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/chart/bar.vue